import $ from "jquery";
import PropTypes from "prop-types";
import React from "react";

/**
 * A select box form component that sets other fields as disabled based on the selected value.
 *
 * @example
 *   <SelectToDisableFields
 *     className="form-control"
 *     defaultValue="in"
 *     disableSelector=".disable-when-off"
 *     disableValue="off"
 *     id="beacon_status_on_entry"
 *     name="beacon[status_on_entry]"
 *     options={[["In", "in"], ["Out", "out"], ["Off", "off"]]}
 *     tabIndex={10}
 *   />
 *   <input className="disable-when-off" name="beacon[comment_on_entry]" type="text" />
 */
class SelectToDisableFields extends React.Component {
  /**
   * Creates the component with the initial state.
   *
   * @param {object} props Initial props
   */
  constructor(props) {
    super(props);
    this.state = { value: props.defaultValue };
    // Bind functions to make `this` available
    this.onChange = this.onChange.bind(this);
  }

  /**
   * Evaluates the selected value and disables the other fields
   * when mounted if the initial value matches the disable value.
   */
  componentDidMount() {
    if (this.state.value === this.props.disableValue) {
      $(this.props.disableSelector).attr("disabled", "disabled");
    }
  }

  /**
   * Handles the onChange event from the select box and disables/enables the other fields.
   *
   * @param {object} event The onChange event from the select box
   */
  onChange(event) {
    const oldValue = this.state.value;
    const newValue = event.target.value;

    this.setState({ value: newValue });

    if (newValue === this.props.disableValue) {
      $(this.props.disableSelector).attr("disabled", "disabled");

      return;
    }

    if (oldValue === this.props.disableValue) {
      $(this.props.disableSelector).removeAttr("disabled");
    }
  }

  /**
   * Renders select box.
   *
   * @returns {object} The React element
   */
  render() {
    /* eslint-disable jsx-a11y/no-onchange */
    return (
      <select
        className={this.props.className}
        id={this.props.id}
        name={this.props.name}
        onChange={this.onChange}
        tabIndex={this.props.tabIndex}
        value={this.state.value}
      >
        {this.props.options.map(option => this.renderOption(option))}
      </select>
    );
    /* eslint-enable jsx-a11y/no-onchange */
  }

  /**
   * Renders an option in the select box.
   *
   * @param {Array} option The pair of strings for label/value
   * @returns {object} The React element
   */
  renderOption(option) {
    const label = option[0];
    const value = option[1];

    return (
      <option key={value} value={value}>
        {label}
      </option>
    );
  }
}

SelectToDisableFields.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  disableSelector: PropTypes.string.isRequired,
  disableValue: PropTypes.string.isRequired,
  id: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  tabIndex: PropTypes.number
};

export default SelectToDisableFields;
